export const getImageForDrinkAndServingSize = (drink, serving) => {
    return `${drink.className}-${serving.sizeMls.toString().replace(".", "-")}`;
};
export const calculateUnits = (drinks) => {
    if (drinks.length === 0) {
        return 0;
    }
    return parseFloat(drinks
        .map(({ drink, serving }) => drink.unitsPerLitre * (Math.floor(serving.sizeMls) / 1000))
        .reduce((acc, val) => acc + val)
        .toFixed(1));
};
export const calculateCalories = (drinks) => {
    if (drinks.length === 0) {
        return 0;
    }
    return parseFloat(drinks
        .map(({ drink, serving }) => drink.caloriesPerLitre * (Math.floor(serving.sizeMls) / 1000))
        .reduce((acc, val) => acc + val)
        .toFixed(1));
};
const servingBottle275 = {
    sizeMls: 275,
    name: "275ml bottle"
};
const servingBottle700 = {
    sizeMls: 700,
    name: "70cl bottle"
};
const servingBottle1000 = {
    sizeMls: 1000,
    name: "1 litre bottle"
};
const servingHalfPint = {
    sizeMls: 284,
    name: "Half pint"
};
const servingCan440 = {
    sizeMls: 440,
    name: "440ml can"
};
const servingCan500 = {
    sizeMls: 500,
    name: "500ml can"
};
const servingBottle500 = {
    sizeMls: 500.1,
    name: "500ml bottle"
};
const servingBottle660 = {
    sizeMls: 660,
    name: "660ml bottle"
};
const servingPint = {
    sizeMls: 568,
    name: "Pint"
};
const servingBottle2000 = {
    sizeMls: 2000,
    name: "2 litre bottle"
};
const servingBox3000 = {
    sizeMls: 3000,
    name: "Box (3 litres)"
};
const servingBottle330 = {
    sizeMls: 330,
    name: "330ml bottle"
};
const servingGlass125 = {
    sizeMls: 125,
    name: "Small glass (125ml)"
};
const servingGlass175 = {
    sizeMls: 175,
    name: "Medium glass (175ml)"
};
const servingGlass250 = {
    sizeMls: 250,
    name: "Large glass (250ml)"
};
const servingBottle187 = {
    sizeMls: 187,
    name: "Piccolo bottle (187ml)"
};
const servingBottle750 = {
    sizeMls: 750,
    name: "Bottle (750ml)"
};
const servingBottle1500 = {
    sizeMls: 1500,
    name: "Magnum (1.5 litre)"
};
const servingGlass25 = {
    sizeMls: 25,
    name: "Single (25ml)"
};
const servingGlass50 = {
    sizeMls: 50,
    name: "Double (50ml)"
};
const servingBottle350 = {
    sizeMls: 350,
    name: "Bottle (350ml)"
};
export const Drinks = [
    {
        className: "alcopop",
        name: "<strong>ALCOPOP</strong><br>4-5% ABV",
        unitsPerLitre: 5,
        caloriesPerLitre: 700,
        servings: [servingBottle275, servingBottle700, servingBottle1000]
    },
    {
        className: "beer-low",
        name: "<strong>BEER, LAGER or ALE</strong><br>4-5% ABV",
        unitsPerLitre: 4,
        caloriesPerLitre: 320,
        servings: [
            servingHalfPint,
            servingBottle330,
            servingCan440,
            servingBottle500,
            servingPint,
            servingBottle1000
        ]
    },
    {
        className: "beer",
        name: "<strong>BEER, LAGER or ALE</strong><br>5-6% ABV",
        unitsPerLitre: 6,
        caloriesPerLitre: 430,
        servings: [
            servingHalfPint,
            servingBottle330,
            servingCan440,
            servingBottle500,
            servingPint,
            servingBottle660,
            servingBottle1000
        ]
    },
    {
        className: "beer-high",
        name: "<strong>SUPER STRENGTH LAGER</strong><br>9% ABV",
        unitsPerLitre: 9,
        caloriesPerLitre: 740,
        servings: [servingCan440, servingCan500]
    },
    {
        className: "cider",
        name: "<strong>CIDER</strong><br>4.5-5% ABV",
        unitsPerLitre: 5,
        caloriesPerLitre: 440,
        servings: [
            servingBottle275,
            servingHalfPint,
            servingCan440,
            servingCan500,
            servingBottle500,
            servingPint,
            servingBottle1000
        ]
    },
    {
        className: "cider-high",
        name: "<strong>CIDER or PERRY</strong><br>7.5% ABV",
        unitsPerLitre: 7.5,
        caloriesPerLitre: 460,
        servings: [
            servingHalfPint,
            servingCan500,
            servingBottle500,
            servingPint,
            servingBottle1000,
            servingBottle2000,
            servingBox3000
        ]
    },
    {
        className: "wine",
        name: "<strong>WINE</strong><br>(Red, White, Ros&#233;)<br>13% ABV",
        unitsPerLitre: 13,
        caloriesPerLitre: 904,
        servings: [
            servingGlass125,
            servingGlass175,
            servingGlass250,
            servingBottle187,
            servingBottle750,
            servingBottle1500,
            servingBox3000
        ]
    },
    {
        className: "champagne",
        name: "<strong>SPARKLING WINE / CHAMPAGNE</strong><br>13% ABV",
        unitsPerLitre: 13,
        caloriesPerLitre: 904,
        servings: [
            servingGlass125,
            servingBottle187,
            servingBottle750,
            servingBottle1500
        ]
    },
    {
        className: "fortified-wine",
        name: "<strong>FORTIFIED WINE</strong><br>(ie Port or Sherry)<br>17.5-20% ABV",
        unitsPerLitre: 20,
        caloriesPerLitre: 1550,
        servings: [
            servingGlass25,
            servingGlass50,
            servingBottle750,
            servingBottle1000
        ]
    },
    {
        className: "spirits-clear",
        name: "<strong>CLEAR SPIRITS</strong><br>37.5-40% ABV",
        unitsPerLitre: 40,
        caloriesPerLitre: 2208,
        servings: [
            servingGlass25,
            servingGlass50,
            servingBottle350,
            servingBottle700,
            servingBottle1000
        ]
    },
    {
        className: "spirits-dark",
        name: "<strong>DARK SPIRITS</strong><br>38-40% ABV",
        unitsPerLitre: 40,
        caloriesPerLitre: 2220,
        servings: [
            servingGlass25,
            servingGlass50,
            servingBottle350,
            servingBottle700,
            servingBottle1000
        ]
    },
    {
        className: "cream-liqueur",
        name: "<strong>CREAM LIQUEUR</strong><br>38-40% ABV",
        unitsPerLitre: 16,
        caloriesPerLitre: 3500,
        servings: [
            servingGlass25,
            servingGlass50,
            servingBottle700,
            servingBottle1000
        ]
    }
];
//# sourceMappingURL=Drinks.js.map